import * as React from 'react';
import {TextInput} from "../inputs/TextInput";
import {EMAIL_REGEX, PHONE_REGEX, Policy, resourcesHelper} from "@falcon/services";
import {getAddress, getInputClassName} from "../../CommonFunctions";

interface IProps {
    policy: Policy,
    contactPhone: string,
    contactEmail: string
    handleDetailsChange: (phone: string, email: string, phoneValid: boolean, emailValid: boolean) => void;
}

interface IState {
    mobile: string;
    email: string;
    mobileValid: boolean;
    emailValid: boolean;
}

export class AccountHolderDetailsPanel extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            mobile: this.props.contactPhone,
            email: this.props.contactEmail,
            mobileValid: PHONE_REGEX.test(this.props.contactPhone),
            emailValid: EMAIL_REGEX.test(this.props.contactEmail)
        }
    }

    public render(): React.ReactNode {
        const policyHolder: any = this.props.policy.policyHolder;
        const realEstate: any = this.props.policy.insuredRealEstates[0];

        return (
            <div className="section-panel">
                <img className="main-icon" src={`/${resourcesHelper.THEME}/img/make-a-claim.png`} alt="Make a claim" aria-label="Make a claim" tabIndex={0}/>
                <div className="section">
                    <div className="section-heading">Cover details</div>
                    <div className="section-contents">
                        <div className="detail">
                            <div className="detail-key font-weight-semi-bold">Account holder</div>
                            <div className="detail-value">{policyHolder.firstName} {policyHolder.lastName}</div>
                        </div>
                        <div className="detail">
                            <div className="detail-key font-weight-semi-bold">Insured address</div>
                            <div className="detail-value">{getAddress(realEstate.address)} {realEstate.address.postalCode}</div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="claim-contact-details-container">
                        <div className="section-heading">Check contact details</div>
                        <p className="text-center">Your changes will not update your Flow account contact details.</p>
                        <TextInput label="Mobile number"
                            id="mobile"
                            value={this.state.mobile}
                            onChange={this.handleContactMobile}
                            className={getInputClassName(this.state.mobileValid)}
                            inputValid={this.state.mobileValid}
                            validationMessage="Invalid UK mobile phone number"
                        />
                        <TextInput label="Email address"
                            id="email"
                            value={this.state.email}
                            onChange={this.handleContactEmail}
                            className={getInputClassName(this.state.emailValid)}
                            inputValid={this.state.emailValid}
                            validationMessage="Invalid email address"
                        />
                    </div>
                    <div className="banner white-blue-bg">
                        <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"/>
                        <div className="font-weight-bold">We’ll send you status updates for your claim using these contact details</div>
                    </div>
                </div>
            </div>
        )
    }

    private handleContactEmail = (event: any): void => {
        const value: string = event.target.value;
        const emailValid: boolean = EMAIL_REGEX.test(value);

        this.setState({
            email: value,
            emailValid
        })

        this.props.handleDetailsChange(this.state.mobile, event.target.value, PHONE_REGEX.test(this.state.mobile), emailValid);
    };

    private handleContactMobile = (event: any): void => {
        const value: string = event.target.value;
        const mobileValid: boolean = PHONE_REGEX.test(value);

        this.setState({
            mobile: value,
            mobileValid
        })

        this.props.handleDetailsChange(event.target.value, this.state.email, mobileValid, EMAIL_REGEX.test(this.state.email));
    };
}



// WEBPACK FOOTER //
// ./src/components/claims/AccountHolderDetailsPanel.tsx